export default __webpack_public_path__ + "static/media/managercentredeprofit.daa3ed99.jpg";